/**
 * Перечень анализов
 *
 * @param {String} params.analyzesWrapper - контейнер списка анализов
 * @param {String} params.urlApi - ссылка на api списка анализов
 * @param {String} params.cityTitle - название города
 * @param {String} params.popular - селект популярых анализов
 * @param {String} params.analyzesFilterWrapper - контейнер фильтра анализов
 * @param {String} params.searchField - поле поиска анализов по названию
 * @param {String} params.availableAtHome - селект доступности на дому
 * @param {String} params.textTab - текстовые вкладки
 * @param {String} params.allAnalyzes - селект всех анализов
 * @param {String} params.isPopular - дата-атрибут популярности анализа
 * @param {String} params.pageTitle - название страницы
 * @param {String} params.slug - ЧПУ
 */
$.fn.analyzesList = function (params) {

    const $self = $(this);
    const $analyzesList = $self.find(params.analyzesWrapper);
    const urlApi = $analyzesList.attr(params.urlApi);
    const cityTitle = $analyzesList.attr(params.cityTitle);
    const $popularAnalyzes = $self.find(params.popular);
    const $analyzesFilterWrapper = $self.find(params.analyzesFilterWrapper);
    const $searchAnalyzeField = $self.find(params.searchField);
    const $availableAtHome = params.availableAtHome;
    const $textTabs = $self.find(params.textTab);
    const $allAnalyzes = $self.find(params.allAnalyzes);

    var analyzeTitle = '';
    var pageTitle = $analyzesList.attr(params.pageTitle);
    var slug = $analyzesList.attr(params.slug);
    var $clearButton = $analyzesFilterWrapper.find('.js-clear-button');
    var atHome = false;


    /**
     * Показать популярные анализы
     */
    $popularAnalyzes.on('click', function () {
        $(this).attr(params.isPopular, true);
        pageTitle = 'Популярные анализы';
        update();
    });

    /**
     * Поле названия услуги
     */
    $self.find($searchAnalyzeField).on('paste keyup change', function () {

        var value = $(this).val();

        if (value !== analyzeTitle) {
            analyzeTitle = value;
            update();
        }
    });

    /**
     * Очистка названия
     */
    $clearButton.on('click', function () {
        analyzeTitle = '';
        update();
    });

    /**
     * Переключатель "доступен на дому"
     */
    $availableAtHome.on('click', function () {
        atHome = !atHome;
        update();
    });

    const update = function () {
        $.ajax({
            method: 'GET',
            url: urlApi,
            data: {
                cityTitle: cityTitle,
                isPopular: $popularAnalyzes.attr(params.isPopular),
                title: analyzeTitle,
                pageTitle: pageTitle,
                slug: slug,
                availableAtHome: atHome,
            }
        }).done(function (res) {
            $analyzesList.html(res);
        }).fail(function (error) {
            console.log(error);
        });

    };

    /**
     * Рендер текстовых вкладок
     */
    $textTabs.each(function () {
        $(this).on('click', function() {
            $.ajax({
                method: 'GET',
                url: $(this).attr('data-url'),
            }).done(function (res) {
                $analyzesList.html(res);
            }).fail(function (error) {
                console.log(error);
            });
        });

    });

    /**
     * Поиск GET параметра в адресной строке
     * @param searchParam
     */
    const getUrlParameter = function getUrlParameter(searchParam) {
        var searchPageURL = window.location.search.substring(1),
            sURLVariables = searchPageURL.split('&'),
            sParameterName,
            i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === searchParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    var availableAtHomeFromUrl = getUrlParameter('availableAtHome');
    var titleFromUrl = getUrlParameter('title');

    if (typeof availableAtHomeFromUrl !== 'undefined' && availableAtHomeFromUrl === 'true') {
        atHome = true;
        $availableAtHome.prop('checked', true);
    }

    if (typeof titleFromUrl !== 'undefined') {
        $searchAnalyzeField.val(titleFromUrl.replace('+', ' '));
    }

    return this;
};

// инициализация
const init = function () {

    $('#js-analyzes-list-module').analyzesList({
        urlApi: 'data-url-api',
        cityTitle: 'data-city-title',
        pageTitle: 'data-page-title',
        analyzesWrapper: '.js-analyzes-wrapper',
        popular: '.js-popular-analyzes',
        analyzesFilterWrapper: '.js-analyzes-filter-wrapper',
        searchField: '.js-search-filter-input',
        availableAtHome: $('[data-available-at-home="false"]'),
        slug: 'data-page-slug',
        isPopular: 'data-is-popular',
        textTab: '.js-text-tab-link',
        allAnalyzes: '.js-all-analyzes'
    });
};

if ($('#js-analyzes-list-module').length > 0) {
    init();
}
